import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Button } from "antd";
import moment from "moment";

import "./Sidebar.css";

class Sidebar extends PureComponent {
  proposalFormation = () => {
    const { request, checkCompanyVehiclesAndDrivers } = this.props;
    checkCompanyVehiclesAndDrivers(request.requestId);
    // this.props.history.push({
    //   pathname: `/offer_create/`,
    //   state: { id: request.requestId },
    // });
  };

  render() {
    let { request, distance, duration } = this.props;
    return (
      <div className="requestCardSidebar">
        <div className="sidebarGroup">
          <Button
            block
            type="primary"
            size="large"
            onClick={() => this.proposalFormation(request.requestTypeId)}
          >
            {request.requestTypeId
              ? request.requestTypeId.requestTypeKey === "fast"
                ? "Ответить на заявку"
                : "Сформировать предложение"
              : "Сформировать предложение"}
          </Button>
        </div>
        <div className="infoBar">
          <span className="infoGroup">
            <span className="name">Заявка</span>
            <span className="value">
              {request.requestTypeId
                ? request.requestTypeId.requestType
                : "Не указано"}
            </span>
          </span>
          <span className="infoGroup">
            <span className="name">Вид</span>
            <span
              className="value"
              style={{
                color: request.requestViewKey !== "free" ? "#f7b500" : "#52c41a"
              }}
            >
              {request.requestViewId
                ? request.requestViewId.requestView.split(" ")[0]
                : "Не указан"}
            </span>
          </span>
          <span className="infoGroup">
            <span className="name">Действует</span>
            <span className="value">
              {request.arrivalDateTime
                ? `до ${moment(request.arrivalDateTime).format("DD.MM.YYYY")}`
                : "Не указан"}
            </span>
          </span>
          <span className="infoGroup">
            <span className="name">НДС</span>
            <span className="value">
              {request.nds !== null
                ? request.nds === "0"
                  ? "Не важно"
                  : "Обязателен"
                : "Не важно"}
            </span>
          </span>
          <span className="infoGroup">
            <span className="name">Сп. оплаты</span>
            <span className="value">
              {request.paymentMethodId !== null
                ? request.paymentMethodId.paymentMethod
                : "Не указан"}
            </span>
          </span>
          <span className="infoGroup">
            <span className="name">Доп. услуги</span>
            <span className="value">
              {request.serviceAdditional && request.serviceAdditional.length
                ? request.serviceAdditional
                    .map(item => item.serviceAdditional)
                    .join(", ")
                : "Не указаны"}
            </span>
          </span>
        </div>
        {request.routes.length ? (
          <div className="infoBar">
            <span className="infoGroup">
              <span className="name" style={{ width: "auto" }}>
                Расчетное время <br /> в пути (по картам)
              </span>
              <span className="value" style={{ width: "auto" }}>
                {duration}
              </span>
            </span>
            <span className="infoGroup">
              <span className="name" style={{ width: "auto" }}>
                Расчетная длина <br />
                маршрута (по картам)
              </span>
              <span className="value" style={{ width: "auto" }}>
                {distance}
              </span>
            </span>
          </div>
        ) : null}
        {/*<div className="sidebarGroup">*/}
        {/*  <Button block size="large" className="btn">*/}
        {/*    О заказчике*/}
        {/*  </Button>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default withRouter(Sidebar);
